/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * A React component for speed icon.
 *
 * @author Ramani Govindaraju
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Speed = props => (
  <SvgIcon fill="#FFF" viewBox="0 0 18 18" {...props}>
    <path
      d="M16.125 11.75h-1.5a.375.375 0 0 1 0-.75h1.5a.375.375 0 0 1 0 .75zM13.85
      8.99a.376.376 0 0 1 .203-.489l1.386-.574a.374.374 0 1 1 .286.693l-1.385.574a.376.376
      0 0 1-.49-.203zM10.5 11a1.501 1.501 0 0 1-3 0c0-.827.673-1.5 1.5-1.5.277
      0 .534.082.757.212l3.486-3.484a.375.375 0 0 1 .53.53l-3.486
      3.484c.132.224.213.48.213.758zM6.99 6.15a.375.375 0 0 1-.49-.202L5.928 4.56a.375.375
      0 1 1 .693-.286l.574 1.385a.375.375 0 0 1-.203.49zM5.288 7.288a.373.373 0 0 1-.53
      0l-1.06-1.061a.376.376 0 0 1 .531-.53l1.06 1.061a.375.375 0 0 1-.001.53zM4.15
      8.991a.376.376 0 0 1-.49.203l-1.386-.575a.375.375 0 1 1
      .287-.692l1.385.574c.192.08.283.3.204.49zm-.775 2.759h-1.5a.375.375 0 0 1
      0-.75h1.5a.375.375 0 0 1 0 .75zm5.25-7.875a.375.375 0 0 1 .75 0v1.5a.375.375 0 0
      1-.75 0v-1.5zm2.181 1.785l.574-1.385a.375.375 0 1 1 .693.287l-.575 1.385a.374.374 0 0
      1-.49.203.374.374 0 0 1-.202-.49zM9 2c-4.963 0-9 4.037-9 9v3.375c0
      .207.168.375.375.375h17.25a.375.375 0 0 0 .375-.375V11c0-4.963-4.037-9-9-9z"
    />
  </SvgIcon>
);

export default Speed;



// WEBPACK FOOTER //
// ./src/js/icons/Speed.jsx